import ServiceBusController from "servicestack/service-bus.controller";
import TagLevel from "servicestack/tags/navigator/tag-navigator-level.model";
import layouts from "servicestack/tags/navigator/tag-navigator.layouts";

export default class TagNavigatorController extends ServiceBusController {
  $onChanges(...changes) {
    const g = this;
    g.layouts = layouts;
    console.debug("$onChanges", { g, changes });
    if (!g.formatter) g.formatter = (t) => t.tagLabel;
    g.levels = (g.navs || []).map((n, i) => new TagLevel(n, i, g));
    g.levels.forEach((l, i) => {
      l.prev = g.levels[i - 1];
      l.next = g.levels[i + 1];
    });

    // console.warn("$g.levels", g.levels);
    const [root] = g.levels;
    if (root) {
      g.root = root;
      root.load();
    }
  }

  heading() {
    if (this.currentLevel) {
      if (this.currentLevel.prev) {
        return this.currentLevel.prev.tagLabel;
      }
    }
    return this.root.tagKind;
  }

  back() {
    this.currentLevel.back();
  }

  select(tag) {
    this.currentLevel.select(tag);
  }

  isSelected(tag) {
    tag && this.currentLevel.isSelected(tag);
  }

  viewAll() {
    this.currentLevel.viewAll();
  }

  templateUrl() {
    return layouts[this.layout];
  }

  scrubClassName(className) {
    return className.split(/\W+/gi).join("-").toLowerCase();
  }

  fillAccordion(level = this.root, result = []) {
    const g = this;
    const css = [
      level === g.currentLevel ? "current-level" : "not-current-level",
      "level-" + level.index,
      "kind-" + g.scrubClassName(level.tagKind),
    ];
    if (level.index === 0 && !level.hideHeading) {
      result.push({
        level,
        label: level.heading(),
        classes: ["heading", ...css],
        select: level.back.bind(level),
      });
    }
    if (level.viewAllLabel) {
      result.push({
        level,
        label: level.viewAllLabel,
        classes: ["view-all", ...css],
        select: level.viewAll.bind(level),
      });
    }
    level.tags.forEach((tag) => {
      result.push({
        level,
        label: tag.tagLabel,
        item: true,
        classes: [
          "tag",
          level.isSelected(tag) ? "active" : "inactive",
          "label-" + g.scrubClassName(tag.tagLabel),
          ...css,
        ],
        select: level.select.bind(level, tag),
      });
      if (level.isSelected(tag) && level.next) {
        g.fillAccordion(level.next, result);
      }
    });
    return result;
  }

  buildAccordion() {
    const g = this;
    const result = g.fillAccordion(g.root, []);
    g.accordionItems = result;
    // console.debug("$buildAccordion", result, g);
    return result;
  }
}
